/// <reference path="FootchinkoItem.ts"/>

import { FootchinkoItem } from "./FootchinkoItem";

import { GameVars } from "../../GameVars";

import { GameConstants } from "../../GameConstants";

import { AudioManager } from "../../AudioManager";

export class Blade extends FootchinkoItem {

    // el png tiene 136 x 46 px
    public static WIDTH: number = 136; // era 120
    public static HEIGHT: number = 46;
    public static TEXTURE_PACKER_PADDING: number = 2;
    public static AXIS_PX: number = 14; // la posicion x del eje dentro de la imagen

    private static ANG_SPEED: number = 0.85;

    constructor(game: Phaser.Game, x: number, y: number, rotation: number, cw: boolean) {

        // si no se suma
        // este factor  1 * Math.abs(Math.sin(rotation) no se centra
        // por que se añade 1 px de  padding en el texture packer
        super(game,
            x - Blade.WIDTH / 2 * Math.cos(rotation) + Blade.HEIGHT / 2 * Math.sin(rotation) + Blade.TEXTURE_PACKER_PADDING / 2 * Math.abs(Math.sin(rotation)),
            y - Blade.WIDTH / 2 * Math.sin(rotation) - Blade.HEIGHT / 2 * Math.cos(rotation) - Blade.TEXTURE_PACKER_PADDING / 2 * Math.abs(Math.cos(rotation)),
            "texture_atlas_1",
            true,
            false,
            rotation);

        this.canBeHit = true;
        this.canBeAffectedByVoodoo = false;

        this.body.angularVelocity = cw ? Blade.ANG_SPEED : - Blade.ANG_SPEED;
    }

    public setBody(): void {

        this.body.setRectangle(108, 35, 62, 0);
        this.body.allowGravity = false;
        this.body.rotation = this.itemRotation;
        this.body.mass = 10e7;
        this.body.allowRotation = true;
        this.body.setZeroVelocity();
        this.body.data.type = Phaser.Physics.P2.Body.KINEMATIC;
        this.body.fixedRotation = false;
        this.body.setZeroDamping();
        this.body.setMaterial(GameVars.getInstance().materials.plankMaterial);
    }

    public setView(): void {

        super.setView();

        this.name = GameConstants.BLADE;

        this.frameName = "blade";
        this.burntFrameName = "burnt-blade";

        this.anchor.setTo(Blade.AXIS_PX / Blade.WIDTH, .5);
    }

    public hit(): void {

        AudioManager.getInstance().playEffect("rebote_pin");
    }
}
